import { createFileRoute } from '@tanstack/react-router';
import ResetPassword from 'containers/Login/ResetPassword';
import { AppLoader } from '../-components/AppLoader';

export const Route = createFileRoute('/login/resetPassword')({
  pendingComponent: AppLoader,
  component: ResetPassword,
});
